import { render, staticRenderFns } from "./TemplateSlides.vue?vue&type=template&id=7975c329&scoped=true&"
import script from "./TemplateSlides.vue?vue&type=script&lang=js&"
export * from "./TemplateSlides.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSlides.vue?vue&type=style&index=0&id=7975c329&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7975c329",
  null
  
)

export default component.exports